<template>

<!--修改logo表单-->
<el-dialog
    v-model="editLogoForm"
    title="修改LOGO"
    width="500"
    destroy-on-close
    center>
    <span>
      <div class="mb-3 row">
        <label for="LogoFile" class="col-sm-2 col-form-label">Logo</label>
        <div class="col-sm-9">
          <input
            type="file"
            class="form-control"
            id="LogoFile"
            />
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>
    </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="editLogoForm = false">取消</el-button>
        <el-button type="submit" @click="editLogoOK();"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>

  <!--修改weather表单-->
<el-dialog
    v-model="editWeatherForm"
    title="修改天气封面"
    width="500"
    destroy-on-close
    center>
    <span>
      <div class="mb-3 row">
        <label for="WeatherFile" class="col-sm-2 col-form-label">封面:</label>
        <div class="col-sm-9">
          <input
            type="file"
            class="form-control"
            id="WeatherFile"
            />
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>
    </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="editWeatherForm = false">取消</el-button>
        <el-button type="submit" @click="editWeatherOK();"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>


<!--修改首页表单-->
<el-dialog
    v-model="editHeaderForm"
    title="修改首页图片"
    width="500"
    destroy-on-close
    center>
    <span>
      <div class="mb-3 row">
        <label for="HeaderFile" class="col-sm-2 col-form-label">封面:</label>
        <div class="col-sm-9">
          <input
            type="file"
            class="form-control"
            id="HeaderFile"
            />
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>
    </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="editHeaderForm = false">取消</el-button>
        <el-button type="submit" @click="editHeaderOK();"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>

  <!-- 修改轮播图 -->
  <el-dialog
    v-model="editLunForm"
    title="修改轮播图"
    width="500"
    destroy-on-close
    center>
    <span>
      <div class="mb-3 row">
        <label for="LunFile" class="col-sm-2 col-form-label">封面:</label>
        <div class="col-sm-9">
          <input
            type="file"
            class="form-control"
            id="LunFile"
            />
        </div>
        <div class="col-sm-1">
          <span style="color: red">*</span>
        </div>
      </div>
    </span>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="editLunForm = false">取消</el-button>
        <el-button type="submit" @click="editLunOK();"> 提交 </el-button>
      </div>
    </template>
  </el-dialog>


  <div class="container introBack">
    <h6 style="font-weight:bold">基本信息</h6>
    <el-row :gutter="20">
    
    <el-col :span="5" class="colBorder">
        <span class="optionFont">网站LOGO:</span>
        <img :src="options && options.logo" class="form-control optionImg" @click="editLogo(options.logo);">
    </el-col>

    <el-col :span="5" class="colBorder">
        <span class="optionFont">天气封面:</span>
        <img :src="options && options.seasoncard" class="form-control optionImg" @click="editWeather(options.seasoncard);">
    </el-col>

    <el-col :span="5" class="colBorder">
        <span class="optionFont">首页页头:</span>
        <img :src="options && options.indexHeader" class="form-control optionImg" @click="editHeader(options.indexHeader);">
    </el-col>

    <el-col :span="9" class="colBorder">
        <span class="optionFont">轮播图:</span>

        <el-carousel style="height: 200px;" >
              <el-carousel-item>
                <h3 class="small justify-center" text="2xl">
                  <img :src="options && options.lun1" class="form-control lunImg" @click="editLun(1, options.lun1);">
                </h3>
              </el-carousel-item>
              <el-carousel-item>
                <h3 class="small justify-center" text="2xl">
                  <img :src="options && options.lun2" class="form-control lunImg" @click="editLun(2, options.lun2);">
                </h3>
              </el-carousel-item>
              <el-carousel-item>
                <h3 class="small justify-center" text="2xl">
                  <img :src="options && options.lun3" class="form-control lunImg" @click="editLun(3, options.lun3);">
                </h3>
              </el-carousel-item>
            </el-carousel>
    </el-col>
    

    <el-col :span="10" class="colBorder">
        <span class="optionFont">页脚标语1:</span>
        <input type="text" class="optionValue form-control" id="footerText1" :value="options && options.footerText1" :disabled="footerText1Flag"/>
        <br>
        <span class="optionFont">页脚标语2:</span>
        <input type="text" class="optionValue form-control" id="footerText2" :value="options && options.footerText2" :disabled="footerText2Flag"/>
    </el-col>
    <el-col :span="1" class="colBorder">
        <span class="disableFont">_</span>
        <el-button type="primary" icon="Edit" class="form-control" v-if="footerText1Flag" @click="footerText1Flag = false" plain />
        <el-button type="success" icon="Finished" class="form-control" v-if="!footerText1Flag" @click="editFooterText1Name()" plain />
        <br>
        <br>
        <br>
        <el-button type="primary" icon="Edit" class="form-control" v-if="footerText2Flag" @click="footerText2Flag = false" plain />
        <el-button type="success" icon="Finished" class="form-control" v-if="!footerText2Flag" @click="editFooterText2Name()" plain />
    </el-col>

</el-row>
    </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import $ from "jquery";
import { ElMessage, ElLoading } from "element-plus";
const options = ref(null);
const footerText1Flag = ref(true);
const footerText2Flag = ref(true);
const editLogoForm = ref(false);
const editWeatherForm = ref(false);
const editHeaderForm = ref(false);
const editLunForm = ref(false);
const Logo = ref("");
const Weather = ref("");
const indexHeader = ref("");
const lunLink = ref("");
const lunType = ref();


onMounted(() => {
    pullOptions();
});

const editLun = (type, link) => {
  lunType.value = type;
  lunLink.value = link;
  editLunForm.value = true;
}

const editWeather = (link) => {
    Weather.value = link;
    editWeatherForm.value = true;
}

const editHeader = (link) => {
    indexHeader.value = link;
    editHeaderForm.value = true;
}


const editLunOK = () => {
     // 判断LOGO
  if ($("#LunFile")[0].files.length == 0) {
    ElMessage({
      type: "error",
      message: "轮播图未上传！",
    });
    return false;
  }

  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })

  const token = localStorage.getItem("token");

  var formData = new FormData();
  formData.append("file", $("#LunFile")[0].files[0]); // 添加LOGO
  formData.append("link", lunLink.value); // 添加ID
  formData.append("type", lunType.value);

  editLunForm.value = false;

  // 修改LOGO
  $.ajax({
    url: "http://124.222.105.205:5000/api/options/editLun",
    type: "post",
    data: formData,
    headers: {
      Authorization: "Bearer " + token,
    },
    processData: false, // 告诉jQuery不要去处理发送的数据
    contentType: false, // 告诉jQuery不要去设置Content-Type请求头
    dataType: "text",
    success: function (resp) {
      let result = JSON.parse(resp);
      if (result.code == "200") {
        ElMessage({
          type: "success",
          message: result.msg,
        });
        pullOptions();
      } else {
        ElMessage({
          type: "error",
          message: result.msg,
        });
      }
      loading.close();
    },
    error: function () {
      ElMessage({
        type: "error",
        message: "更改轮播图失败！",
      });
      loading.close();
    },
  });
}

const editHeaderOK = () => {
     // 判断LOGO
  if ($("#HeaderFile")[0].files.length == 0) {
    ElMessage({
      type: "error",
      message: "封面未上传！",
    });
    return false;
  }

  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })

  const token = localStorage.getItem("token");

  var formData = new FormData();
  formData.append("file", $("#HeaderFile")[0].files[0]); // 添加LOGO
  formData.append("link", indexHeader.value); // 添加ID

  editHeaderForm.value = false;

  // 修改LOGO
  $.ajax({
    url: "http://124.222.105.205:5000/api/options/editIndexHeader",
    type: "post",
    data: formData,
    headers: {
      Authorization: "Bearer " + token,
    },
    processData: false, // 告诉jQuery不要去处理发送的数据
    contentType: false, // 告诉jQuery不要去设置Content-Type请求头
    dataType: "text",
    success: function (resp) {
      let result = JSON.parse(resp);
      if (result.code == "200") {
        ElMessage({
          type: "success",
          message: result.msg,
        });
        pullOptions();
      } else {
        ElMessage({
          type: "error",
          message: result.msg,
        });
      }
      loading.close();
    },
    error: function () {
      ElMessage({
        type: "error",
        message: "更改首页封面失败！",
      });
      loading.close();
    },
  });
}

const editLogo = (link) => {
    Logo.value = link;
    editLogoForm.value = true;
}

const editLogoOK = () => {
     // 判断LOGO
  if ($("#LogoFile")[0].files.length == 0) {
    ElMessage({
      type: "error",
      message: "LOGO未上传！",
    });
    return false;
  }

  const token = localStorage.getItem("token");

  var formData = new FormData();
  formData.append("file", $("#LogoFile")[0].files[0]); // 添加LOGO
  formData.append("link", Logo.value); // 添加ID

  editLogoForm.value = false;

  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })

  // 修改LOGO
  $.ajax({
    url: "http://124.222.105.205:5000/api/options/editLogo",
    type: "post",
    data: formData,
    headers: {
      Authorization: "Bearer " + token,
    },
    processData: false, // 告诉jQuery不要去处理发送的数据
    contentType: false, // 告诉jQuery不要去设置Content-Type请求头
    dataType: "text",
    success: function (resp) {
      let result = JSON.parse(resp);
      if (result.code == "200") {
        ElMessage({
          type: "success",
          message: result.msg,
        });
        pullOptions();
      } else {
        ElMessage({
          type: "error",
          message: result.msg,
        });
      }
      loading.close();
    },
    error: function () {
      ElMessage({
        type: "error",
        message: "更改LOGO失败！",
      });
      loading.close();
    },
  });
}

const editWeatherOK = () => {
     // 判断LOGO
  if ($("#WeatherFile")[0].files.length == 0) {
    ElMessage({
      type: "error",
      message: "封面未上传！",
    });
    return false;
  }

  const token = localStorage.getItem("token");

  var formData = new FormData();
  formData.append("file", $("#WeatherFile")[0].files[0]); // 添加LOGO
  formData.append("link", Weather.value); // 添加ID

  editWeatherForm.value = false;

  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)',
  })

  // 修改LOGO
  $.ajax({
    url: "http://124.222.105.205:5000/api/options/editWeather",
    type: "post",
    data: formData,
    headers: {
      Authorization: "Bearer " + token,
    },
    processData: false, // 告诉jQuery不要去处理发送的数据
    contentType: false, // 告诉jQuery不要去设置Content-Type请求头
    dataType: "text",
    success: function (resp) {
      let result = JSON.parse(resp);
      if (result.code == "200") {
        ElMessage({
          type: "success",
          message: result.msg,
        });
        pullOptions();
      } else {
        ElMessage({
          type: "error",
          message: result.msg,
        });
      }
      loading.close();
    },
    error: function () {
      ElMessage({
        type: "error",
        message: "更改天气封面失败！",
      });
      loading.close();
    },
  });
}

const pullOptions = () => {
    $.ajax({
    type: "post",
    url: "http://124.222.105.205:5000/visitor/api/options/GetOptions",
    data: "",
    success: function (res) {
      if (res.code == 200) {
        options.value = res.data;
      } else {
        ElMessage({
            type:"error",
            message: res.msg
        });
      }
    },
    error: function() {
        ElMessage({
            type:"error",
            message:"拉取数据失败!"
        });
    }
  });
}


const editFooterText1Name = () => {
    footerText1Flag.value = true;

    let text = $("#footerText1").val();

    if (text == null || text == "") {
        ElMessage({
            type: "error",
            message: "标语未填！",
        });
        return false;
    }

    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/options/updateFooterText1",
        data: {
            text: text,
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
                pullOptions();
            }
            if (resp.code != "200") {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "修改标语失败",
            });
        },
    });

}


const editFooterText2Name = () => {
    footerText2Flag.value = true;

    let text = $("#footerText2").val();

    if (text == null || text == "") {
        ElMessage({
            type: "error",
            message: "标语未填！",
        });
        return false;
    }

    const token = localStorage.getItem("token");
    $.ajax({
        url: "http://124.222.105.205:5000/api/options/updateFooterText2",
        data: {
            text: text,
        },
        type: "post",
        headers: {
            Authorization: "Bearer " + token,
        },
        success(resp) {
            if (resp.code == "200") {
                ElMessage({
                    type: "success",
                    message: resp.msg,
                });
                pullOptions();
            }
            if (resp.code != "200") {
                ElMessage({
                    type: "error",
                    message: resp.msg,
                });
            }
        },
        error() {
            ElMessage({
                type: "error",
                message: "修改标语失败",
            });
        },
    });

}


</script>

<style scoped>
.optionFont {
    color: rgb(83, 83, 83);
    font-weight: bold;
    margin: 15px;
    padding: 5px;
}

.optionImg {
    width: 200px;
}

.lunImg {
  width: 102%;
  height: 200px;
  margin: 5px 0px;
}

.optionValue{
    color: rgb(47, 47, 47);
}

.colBorder {
    margin-bottom: 40px;
}


.optionBtn {
    padding-left: 0px;
}

.disableFont {
    color: rgba(240, 248, 255, 0);
}

.introBack {
    background-color: rgba(201, 201, 201, 0.055);
    padding: 5px;
}

</style>